export interface NotificationI {
  id: string;
  type: 'success' | 'error' | 'warning' | 'info';
  color: 'green' | 'red' | 'yellow' | 'blue';
  title: string;
  message: string;
  closeIn: number;
  seconds: number;
}

export interface NotificationStateI {
  notifications: NotificationI[];
}

export const state: NotificationStateI = {
  notifications: [],
};
